import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from '@mui/material'
import { useSnackbar } from 'notistack'
import { useDeleteMapTrans } from '../../../hooks/api/map-transactions'
import { extractErrorMessage } from '../../../utils/extractErrorMessage'

const Delete = ({ open, data, setOpen, refetch }) => {
  const { mutateAsync, isLoading } = useDeleteMapTrans()
  const { enqueueSnackbar } = useSnackbar()

  const onClose = () => setOpen(false)

  const handleDelete = async () => {
    try {
      await mutateAsync({ id: data.id })
      enqueueSnackbar('Transaction has been successfully removed.', { variant: 'success' })
      onClose()
      refetch()
    } catch (e) {
      enqueueSnackbar(extractErrorMessage(e), { variant: 'error' })
    }
  }

  return (
    <Dialog maxWidth='sm' open={open}>
      <DialogTitle>Confirm Deletion</DialogTitle>
      <DialogContent dividers>
        <Typography>
          Are you sure you want to remove <b>{data.description}</b> from the transaction list? This
          action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button variant='contained' color='secondary' onClick={handleDelete} disabled={isLoading}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default Delete
